import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { User } from '../_models/shared/_index';
import { SessionService } from '../_services/session.service';
import { catchError, map } from 'rxjs/operators';
import { of as observableOf } from 'rxjs';

@Injectable()
export class PerfilGuard implements CanActivate {

    constructor(private router: Router, private sessionService: SessionService) { }

    user: User = this.sessionService.getCurrentUser();

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

        return this.sessionService.getSessionActive().pipe(map(loggedIn => {

            let urlInicial: string = "/login";

            if (loggedIn.Succeed) {
                this.sessionService.setCurrentUser(loggedIn.Data);
                urlInicial = this.sessionService.obtenerUrlInicial();
            }

            this.router.navigate([urlInicial]);

            return loggedIn.Succeed;

        }), catchError(() => {
            this.router.navigate(['/NoConnection'], { queryParams: { returnUrl: state.url } });
            return observableOf(false);
        }));

    }
}